/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaB2BOrderDetailData } from './aaa_b2b_order_detail.data';
import { IAaa_b2b_order_detailProps } from './aaa_b2b_order_detail.props.autogenerated';
import { getRequestOrderAsync, updateRequestOrderAsync } from '../../dataActions/DataActionExtension.g';
import { FullProductInput, getFullProducts, getProductDetailsCriteriaFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { addCartLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { getCartState } from '@msdyn365-commerce/global-state';
import moment from 'moment';
import { Button } from '@msdyn365-commerce-modules/utilities';
import { reaction } from 'mobx';

export interface IAaa_b2b_order_detailViewProps extends IAaa_b2b_order_detailProps<IAaaB2BOrderDetailData> {
    requestOrderDetail: any;
    isLoading: boolean;
    addItemToCart: any;
    toasterInfo: any;
    removePopUp: any;
    _renderPopUp?: any;
    _togglePopUp?: any;
}

/**
 *
 * Aaa_b2b_order_detail component
 * @extends {React.PureComponent<IAaa_b2b_order_detailProps<IAaaB2BOrderDetailData>>}
 */
class Aaa_b2b_order_detail extends React.PureComponent<IAaa_b2b_order_detailProps<IAaaB2BOrderDetailData>, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            requestOrderDetail: {},
            toasterInfo: { visible: false },
            removePopUp: { visible: false },
            cart: undefined,
            isLoading: true
        };
    }

    public async componentDidMount(): Promise<void> {
        reaction(
            () => this.props.data.cart.result?.cart,
            async () => {
                if (this.props.data.cart.result?.cart) {
                    const cart: any = this.props.data.cart.result?.cart;
                    const params = new URLSearchParams(this.props.context.request.url.requestUrl.search);
                    var requestOrderId: string | null = '';
                    var lineNum: string | null = '';
                    if (params.has('requestOrderId') && params.has('lineNum')) {
                        // check url has recordId...
                        requestOrderId = params.get('requestOrderId');
                        lineNum = params.get('lineNum');
                    }
                    await this.getRequestOrder(requestOrderId, lineNum, cart);
                    this.setState({ cart: cart });
                }
            }
        );
    }

    public getRequestOrder = async (requestOrderId: any, lineNum: any, cart: any) => {
        const response: any = await getRequestOrderAsync(
            {
                callerContext: this.props.context.actionContext,

                queryResultSettings: {}
            },
            requestOrderId
        );

        if (response.RequestOrder.length > 0) {
            const productInputs: any = [];
            response.RequestOrder.map((requestOrder: any) => {
                if (requestOrder.ProductId) {
                    productInputs.push(
                        new FullProductInput(
                            requestOrder.ProductId,
                            this.props.context.actionContext.requestContext.apiSettings,
                            getProductDetailsCriteriaFromActionInput(this.props.context.actionContext)
                        )
                    );
                }
            });
            if (productInputs.length > 0) {
                return getFullProducts(productInputs, this.props.context.actionContext).then(async products => {
                    if (products) {
                        // mapping data....
                        const requestOrders = response.RequestOrder.filter((order: any) => {
                            return order.RequestOrderId === requestOrderId && order.LineNum.toString() === lineNum;
                        });
                        requestOrders.map((order: any) => {
                            const product: any = products.find((p: any) => {
                                return order.ProductId === p.ProductDetails.RecordId;
                            });
                            let matchedCartProducts = [];
                            if (product && order.ProductId && cart) {
                                const requestOrderDetail: any = {
                                    imageUrl: order.HighResImageURL,
                                    productName: order.ProductName,
                                    stockistInfo: {
                                        name: order.b2CCustomerName,
                                        phoneNumber: order.B2CPhone,
                                        email: order.B2CEmailId
                                    },
                                    statusName: order.StatusName,
                                    snapShotId: order.Snapshotid,
                                    orderNumber: order.RequestOrderId,
                                    orderDate: order.DateTime ? moment(order.DateTime).format('DD/MM/YYYY') : '-',
                                    rings: [],
                                    totalPrice: order.B2CPrice.toLocaleString(),
                                    b2cPrice: order.B2CPrice,
                                    quantity: order.Quantity,
                                    product: product,
                                    lineNum: lineNum
                                };
                                const requestOrderLines = JSON.parse(order.RequestOrderLines);
                                for (const ring of requestOrderLines) {
                                    const ringSizePi = parseFloat(ring.RingSize.split('mm')[0]) / 3.14159265;
                                    const ringInfo = {
                                        name: ring.DetailName,
                                        alloy: ring.Alloy1,
                                        engravingFont: ring.EngravingText ? ring.EngravingFont : '-',
                                        sizeLabel: ring.RingSizeLabel,
                                        sizeValue:
                                            Math.round(
                                                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                                                (ringSizePi + Number.EPSILON) * 100
                                            ) / 100,
                                        engravingCopy: ring.EngravingText ? ring.EngravingText : '-',
                                        specifications: ring.DiamondCount
                                            ? `${ring.DiamondCount} Diamonds, ${ring.RingWidth} Wide, ${ring.RingHeight} thick`
                                            : `${ring.RingWidth} Wide, ${ring.RingHeight} thick`,
                                        price: ring.B2CPrice.toLocaleString()
                                    };
                                    requestOrderDetail.rings.push(ringInfo);
                                }
                                matchedCartProducts = cart.CartLines.filter((cartLine: any) => {
                                    return order.ProductId === cartLine.ProductId;
                                });
                                requestOrderDetail.orderExistInCart = matchedCartProducts.some((p: any) => {
                                    let requestOrderId = '';
                                    let lineId = null;
                                    let snapShotId = '';
                                    if (p.ExtensionProperties.length > 0) {
                                        p.ExtensionProperties.forEach((e: any) => {
                                            if (e.Key === 'AAA_REQUESTORDERID') {
                                                requestOrderId = e.Value.StringValue;
                                            }
                                            if (e.Key === 'AAA_REQUESTORDERLINENUM') {
                                                lineId = e.Value.DecimalValue;
                                            }
                                            if (e.Key === 'AAA_SNAPSHOTID') {
                                                snapShotId = e.Value.StringValue;
                                            }
                                        });
                                    }

                                    return (
                                        requestOrderDetail.orderNumber === requestOrderId &&
                                        requestOrderDetail.snapShotId === snapShotId &&
                                        Number(requestOrderDetail.lineNum) === lineId
                                    );
                                });
                                if (!requestOrderDetail.orderExistInCart) {
                                    // generate order reference...
                                    const weekday = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

                                    const d = new Date();
                                    const day = weekday[d.getDay()];
                                    const year = new Date()
                                        .getFullYear()
                                        .toString()
                                        .substr(-2);
                                    const oneDigitRandomNumber = Math.floor(1 + Math.random() * 9);
                                    const fourDigitRandomNumber = Math.floor(1000 + Math.random() * 9000);
                                    // eslint-disable-next-line radix
                                    let priceInFloat = parseInt(order.B2BPrice).toString();
                                    priceInFloat = priceInFloat.padStart(4, '0');
                                    requestOrderDetail.referenceNumber = `${day}${year}-${oneDigitRandomNumber}${priceInFloat}-${fourDigitRandomNumber}`;
                                } else {
                                    const matchedCartItem = matchedCartProducts.find((p: any) => {
                                        let requestOrderId = '';
                                        let lineId = null;
                                        let snapShotId = '';
                                        if (p.ExtensionProperties.length > 0) {
                                            p.ExtensionProperties.forEach((e: any) => {
                                                if (e.Key === 'AAA_REQUESTORDERID') {
                                                    requestOrderId = e.Value.StringValue;
                                                }
                                                if (e.Key === 'AAA_REQUESTORDERLINENUM') {
                                                    lineId = e.Value.DecimalValue;
                                                }
                                                if (e.Key === 'AAA_SNAPSHOTID') {
                                                    snapShotId = e.Value.StringValue;
                                                }
                                            });
                                        }
                                        return (
                                            requestOrderId === requestOrderDetail.orderNumber &&
                                            lineId === Number(requestOrderDetail.lineNum) &&
                                            snapShotId === requestOrderDetail.snapShotId
                                        );
                                    });
                                    if (matchedCartItem && matchedCartItem.ExtensionProperties.length > 0) {
                                        const matchedCartReferenceNumber = matchedCartItem.ExtensionProperties.find((e: any) => {
                                            return e.Key === 'AAA_REFERENCENUMBER' && e.Value.StringValue;
                                        });
                                        if (matchedCartReferenceNumber) {
                                            requestOrderDetail.referenceNumber = matchedCartReferenceNumber.Value.StringValue;
                                        }
                                    }
                                }
                                this.setState({ requestOrderDetail, isLoading: false });
                            }
                        });
                    }
                });
            }
        }
    };

    private readonly _addItemToCart = (requestOrderLine: any) => {
        const { context } = this.props;
        // const { cart } = data;
        const product = requestOrderLine.product.ProductDetails;
        if (context) {
            if (this.state.cart) {
                const addCartLines = {
                    CatalogId: context.request.apiSettings.catalogId,
                    Description: product.Description,
                    EntryMethodTypeValue: 3,
                    ItemId: product.ItemId,
                    ProductId: product.RecordId,
                    Quantity: requestOrderLine.quantity,
                    IsPriceKeyedIn: true,
                    TrackingId: '',
                    UnitOfMeasureSymbol: product.DefaultUnitOfMeasure,
                    IsGiftCardLine: false,
                    Price: requestOrderLine.b2cPrice,
                    ExtensionProperties: [
                        {
                            Key: 'AAA_SNAPSHOTID',
                            Value: {
                                StringValue: requestOrderLine.snapShotId
                            }
                        },
                        {
                            Key: 'AAA_REQUESTORDERID',
                            Value: {
                                StringValue: requestOrderLine.orderNumber
                            }
                        },
                        {
                            Key: 'AAA_REQUESTORDERLINENUM',
                            Value: {
                                DecimalValue: Number(requestOrderLine.lineNum)
                            }
                        },
                        {
                            Key: 'AAA_REFERENCENUMBER',
                            Value: {
                                StringValue: requestOrderLine.referenceNumber
                            }
                        }
                    ]
                };
                if (!requestOrderLine.snapShotId) {
                    addCartLines.IsPriceKeyedIn = false;
                }
                addCartLinesAsync(
                    { callerContext: context.actionContext, queryResultSettings: {} },
                    this.state.cart.Id,
                    [addCartLines],
                    this.state.cart.Version
                )
                    .then(async response => {
                        this.toggleSnackBar('success', 'Item Added to Cart...');
                        const cartState = await getCartState(this.props.context.actionContext);
                        await cartState.refreshCart({});
                        // redirect to manage orders..
                        this.moveToManageOrderPage();
                    })
                    .catch(err => {
                        this.toggleSnackBar('error', 'Add Cart failed');
                    });
            }
        }
    };
    private moveToManageOrderPage = () => {
        const request = this.props.context.request;
        let orderDetailUrl = request.url.requestUrl.origin;
        if (request.sitePath) {
            orderDetailUrl = orderDetailUrl + request.sitePath;
        }
        if (request) {
            window.location.href = `${orderDetailUrl}${this.props.config.redirectToManageOrdersUrl}`;
        }
    };
    public toggleSnackBar = (type: string, message: string) => {
        const toasterInfo = { visible: true, type: type, message: message };
        this.setState({ toasterInfo });
        // After 3 seconds, remove the show class from DIV
        setTimeout(() => {
            const toasterInfo = { visible: false, type: '', message: '' };
            this.setState({ toasterInfo });
        }, 3000);
    };
    public removeOrderRequestLine = async () => {
        if (!this.state.requestOrderDetail.orderNumber) {
            return;
        }
        await updateRequestOrderAsync(
            { callerContext: this.props.context.actionContext, queryResultSettings: {} },
            this.state.requestOrderDetail.orderNumber,
            Number(this.state.requestOrderDetail.lineNum),
            2
        )
            .then(response => {
                this.toggleSnackBar('success', 'Removed Item from Order Request Lines...');
                this.togglePopUp(false);
                // redirect to manage orders..
                this.moveToManageOrderPage();
            })
            .catch(err => {
                this.toggleSnackBar('error', 'Remove Item failed');
            });
    };
    private _renderPopUp = () => {
        const orderConfirmPopHeader: string = this.props.config.cancelPopUpHeading ? this.props.config.cancelPopUpHeading : '';
        const orderConfirmPopContent: string = this.props.config.cancelPopUpContent ? this.props.config.cancelPopUpContent : ``;
        return (
            <div
                id='popup1'
                style={{
                    position: 'fixed',
                    top: '50px !important',
                    left: 0,
                    right: 0,
                    visibility: 'visible',
                    opacity: 1,
                    zIndex: 9
                }}
            >
                <div
                    style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        background: '#fff',
                        border: '1px solid #d2d0d0',
                        width: '30%',
                        position: 'relative',
                        transition: 'all 5s ease-in-out',
                        boxShadow: '5px 8px 5px 2px #888888'
                    }}
                >
                    <div style={{ background: '#f8f8f8', borderBottom: '1px solid #d2d0d0', padding: 22 }}>
                        <h2 style={{ textAlign: 'center', marginLeft: 10 }}>{orderConfirmPopHeader}</h2>
                        <a
                            onClick={() => {
                                this.togglePopUp(false);
                            }}
                            style={{
                                position: 'absolute',
                                top: '20px',
                                right: '30px',
                                transition: 'all 200ms',
                                fontSize: '30px',
                                fontWeight: 'bold',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                color: '#333'
                            }}
                        >
                            &times;
                        </a>
                    </div>
                    <div style={{ maxHeight: '30%', padding: 10, overflow: 'auto', textAlign: 'center' }}> {orderConfirmPopContent}</div>
                    <div style={{ maxHeight: '30%', padding: 10, overflow: 'auto', textAlign: 'center' }}>
                        <Button
                            className='ms-wishlist-items__product-add-button'
                            title={'YES,REMOVE'}
                            style={{ marginBottom: '5px', marginLeft: '5px', cursor: 'pointer' }}
                            onClick={() => this.removeOrderRequestLine()}
                        >
                            {'YES,REMOVE'}
                        </Button>
                        <Button
                            className='ms-wishlist-items__product-add-button'
                            title={'NO'}
                            style={{ marginBottom: '5px', marginLeft: '5px', cursor: 'pointer' }}
                            onClick={() => this.togglePopUp(false)}
                        >
                            {'NO'}
                        </Button>
                    </div>
                </div>
            </div>
        );
    };
    private togglePopUp = (visible: boolean) => {
        const removePopUpVisible: any = visible;
        this.setState({ removePopUp: { visible: removePopUpVisible } });
    };
    public render(): JSX.Element | null {
        const viewProps: IAaa_b2b_order_detailViewProps = {
            ...(this.props as IAaa_b2b_order_detailProps<IAaaB2BOrderDetailData>),
            requestOrderDetail: this.state.requestOrderDetail,
            addItemToCart: this._addItemToCart,
            toasterInfo: this.state.toasterInfo,
            removePopUp: this.state.removePopUp,
            _renderPopUp: this._renderPopUp,
            _togglePopUp: this.togglePopUp,
            isLoading: this.state.isLoading
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Aaa_b2b_order_detail;
